<template>

	<div class="map-box">
		<div class="search-main">
			<div class="public_oparetionBlock_Menu">
				<label class="public_lbSty">车牌号：</label>
				<div class="el-select public_optionSty">
					<div class="el-input el-input--suffix">
						<input class="pulic_carNumber" type="text" placeholder="请输入" v-model="carNumber" />
					</div>
				</div>
			</div>
			<div class="public_operatArea_timePicker pulic_cursor">
				<el-date-picker v-model="date" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
					range-separator="至" :picker-options="startDateDisabled" @change="datePickerChange"
					start-placeholder="开始日" end-placeholder="结束日" class="pulic_cursor">
				</el-date-picker>
			</div>
			<el-button style="margin-left: 20px; font-size: 20px;" type="primary" @click="queryClick"
				class="pulic_cursor" v-shiroHiden="solelist" id="查询">查询</el-button>
		</div>

		<div class="carInfoBox" v-if="mapStatus == 1">
			<div class="carInfo">
				<span>车牌号：豫K85M21</span>
				<span class="carNo">{{carNumber}}</span>
			</div>
			<!-- <p class="title">24小时车辆运行情况:</p> -->
			<div class="rote-box">
				<el-timeline :reverse="true">
					<el-timeline-item v-for="(activity, index) in activities" :key="index" icon="el-icon-coordinate"
						type="primary" :color="activity.color" size="large" :timestamp="activity.timestamp">
						{{ activity.content }}
					</el-timeline-item>
				</el-timeline>
			</div>
		</div>
		<div class="returnBtn" @click="addMarker" v-if="mapStatus == 1">返回</div>
		<div id="container"></div>
	</div>
</template>
<script>
	import AMapLoader from "@amap/amap-jsapi-loader";
	import moment from "moment";
	export default {
		// name: "map-view",
		// props: ["lntlat", "carInfo"],
		data() {
			return {
				map: "",
				marker: null,
				routeLine: null,
				startMarker: null,
				endMarker: null,
				lntlat: [
					[113.858476, 34.041432],
					[113.526732, 34.280633]
				],
				carInfo: {
					id: "1-2",
					label: "",
					type: 2,
					rotes: {
						startTime: "2024-01-16 10:44",
						endTime: "2023-01-17 10:44",
						startLocation: [118.46999, 37.520299],
						endLocation: [117.131897, 36.162652],
					},
				},
				activities: [{
						content: "河南省许昌市魏都区前进路",
						timestamp: "2024-05-19 10:50",
					},
					{
						content: "河南省许昌市禹州市无梁镇桐树张村",
						timestamp: "2024-05-19 10:02",
					},
				],
				colorTim: "#fff",
				carNumber: '',
				startDateDisabled: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				solelist: [],
				date: [], //日期
				startTime: '',
				endTime: '',
				dateNowDayActive: false,
				dateYesterdayActive: false,
				dateNowMonthActive: false,
				dateLastMonthActive: false,
				mapStatus: 0,
			};
		},
		watch: {
			lntlat: {
				handler: function(newVal, oldVal) {
					this.$nextTick(() => {
						if (this.map) {
							this.removeMarker();
							this.addMarker();
						}
					});
				},
				deep: true,
			},
			carInfo() {
				this.activities[0].timestamp = moment().format("YYYY-MM-DD HH:mm");
				this.activities[1].timestamp = moment().subtract(1, "day").format("YYYY-MM-DD HH:mm");
			},
		},
		created() {
			var list = "";
			list = this.$store.state.solelist;
			var path = this.$route.path;
			if (path === '/oilCardTrajectory') {
				path = '/Home' + path
			}
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表

			// console.log(this.uobj)
		},
		mounted() {
			window._AMapSecurityConfig = {
				securityJsCode: "146c85b43411dda7483a07f9207537d6", //安全秘钥
			};
			this.initAMap();
		},
		unmounted() {
			this.map.destroy();
		},
		methods: {
			datePickerChange(e) {
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			// 查询
			queryClick() {
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.pageList()
			},

			// 列表
			pageList() {
				// var ORMTB400CA03
				// if (this.uobj.pertb005.pertb005cb00 == "CUS-2") {
				// 	ORMTB400CA03 = this.uobj.ormtb410.ORMTB410ID
				// }
				// if (this.uobj.pertb005.pertb005cb00 == "CUS-1") {
				// 	ORMTB400CA03 = this.uobj.ormtb400.ORMTB400CA03
				// }

				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					startTime: this.startTime, //开始时间
					endTime: this.endTime, //结束时间
					// ORMTB440CA02: this.customerMo, //二级客户ID
					// // ORMTB400CA03: ORMTB400CA03, //一级客户代码
					// ORMTB440CA04: this.enterpriseTwo, //二级企业ID
					// ORMTB440CA06: this.materielMo, //物料ID
					// ORMTB440CF01: this.SETTB122CA07, //状态
					// ORMTB440CA29: this.ORMTB440CA29, //状态
					// ORMTB440CA00: this.ORMTB440CA00, //订单号
					car: this.carNumber, //车牌号
					// PERTB005ID: this.$store.state.uobj.pertb005.pertb005id, //角色ID
					// page: this.pageMo,
					// limit: this.limitMo,
					// timeType: this.timeType
				}
				this.tableData = [];
				var url = "/system/fetchTrack";
				this.axios.post(url, postData).then(res => {
					setTimeout(() => {
						loading.close()
					}, 400)
					console.log(res)
					if (res.data.code == 200) {
						var data = res.data.data;
						// console.log(data)
						const chars = JSON.parse(data)
						this.carInfo.label = this.carNumber
						// const chars1 = chars[0].split(' ');
						// const chars2 = chars1[0].parkArray.split(' ');
						console.log(chars)
						console.log(this.carInfo.label)

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},

			initAMap() {
				let that = this;
				AMapLoader.load({
						key: "3QFBZ-U4WC5-2SWI3-IWRW4-3PNI6-6LBGC", // 申请好的Web端开发者Key，首次调用 load 时必填
						version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
						plugins: [
							"AMap.ToolBar",
							"AMap.Scale",
							"AMap.HawkEye",
							"AMap.MapType",
							"AMap.Geolocation",
							"AMap.ControlBar",
							"AMap.MoveAnimation",
							"AMap.Driving",
							"AMap.Geocoder",
						], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
					})
					.then((AMap) => {
						that.map = new AMap.Map("container", {
							// 设置地图容器id
							viewMode: "3D", // 是否为3D地图模式
							zooms: [5, 14], // 初始化地图级别
							center: [113.858476, 34.041432], // 初始化地图中心点位置
							pitch: 45,
						});
						that.addMarker();
						window.calcDriving = () => {
							that.calcDriving();
						};
					})
					.catch((e) => {
						console.log(e);
					});
			},
			removeMarker() {
				this.marker && this.map.remove(this.marker);
			},
			removeRouteLine() {
				this.startMarker && this.map.remove(this.startMarker);
				this.endMarker && this.map.remove(this.endMarker);
				this.routeLine && this.map.remove(this.routeLine);
			},
			addMarker() {
				this.removeRouteLine();
				let that = this;
				this.mapStatus = 0;
				// 创建 AMap.Icon 实例：
				var icon = new AMap.Icon({
					size: new AMap.Size(20, 20), // 图标尺寸
					image: require("@/assets/gps.png"), // Icon的图像
					imageSize: new AMap.Size(20, 20), // 根据所设置的大小拉伸或压缩图片
				});
				this.marker = new AMap.Marker({
					icon: icon,
					position: this.lntlat[0],
					offset: new AMap.Pixel(-10, -10),
				});
				this.map.add(this.marker);
				this.map.setFitView();

				// infowidnow 的 innerHTML
				var infoWindowContent = `
      <div class="map-info">
        <div class="info-item">
          <span>车牌号:</span>
          <span>${this.carInfo.label || "--"}</span>
        </div>
        
        <div class="line"></div>
        <div class="button" onclick="calcDriving()">查看车辆轨迹 ></div>
      </div>
      `;

				// 创建一个自定义内容的 infowindow 实例
				var infoWindow = new AMap.InfoWindow({
					position: this.lntlat[0],
					offset: new AMap.Pixel(0, -10),
					content: infoWindowContent,
				});
				infoWindow.open(that.map);
				this.marker.on("click", function() {
					infoWindow.open(that.map);
				});
				this.map.setFitView(null, false);
			},

			regeoCode(lnglat, id) {
				let that = this;
				var geocoder = new AMap.Geocoder({
					// city: "010", //城市设为北京，默认：“全国”
					enableHighAccuracy: true,
					radius: 1000, //范围，默认：500
				});
				geocoder.getAddress(lnglat, function(status, result) {
					if (status === "complete" && result.regeocode) {
						var address = result.regeocode.formattedAddress;

						console.log(result)
						that.activities[id].content = address;
						// that.activities[0].timestamp = carInfo.rotes.startTime

					} else {
						console.log("根据经纬度查询地址失败");
					}
				});
			},
			calcDriving() {
				this.removeMarker();
				this.map.clearInfoWindow();
				this.mapStatus = 1;
				this.regeoCode(this.carInfo.rotes.startLocation, 0);
				this.regeoCode(this.carInfo.rotes.endLocation, 1);
				let that = this;
				var drivingOption = {
					policy: AMap.DrivingPolicy
						.LEAST_TIME, // 其它policy参数请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingPolicy
					ferry: 1, // 是否可以使用轮渡
					province: "", // 车牌省份的汉字缩写
				};

				// 构造路线导航类
				var driving = new AMap.Driving(drivingOption);

				// 根据起终点经纬度规划驾车导航路线
				driving.search(this.lntlat[0], this.lntlat[1], function(status, result) {
					console.log(result)
					// result即是对应的驾车导航信息，相关数据结构文档请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
					if (status === "complete") {
						if (result.routes && result.routes.length) {
							// 绘制第一条路线，也可以按需求绘制其它几条路线
							that.drawRoute(result.routes[0]);
							console.log('绘制驾车路线完成')
						}
					} else {
						console.log('获取驾车数据失败：' + result)
					}
				});
			},
			drawRoute(route) {
				var path = this.parseRouteToPath(route);
				var icon = new AMap.Icon({
					size: new AMap.Size(20, 20), // 图标尺寸
					// image: require("@/assets/mapMarker.png"), // Icon的图像
					imageSize: new AMap.Size(20, 20), // 根据所设置的大小拉伸或压缩图片
				});
				this.startMarker = new AMap.Marker({
					position: path[0],
					icon: icon,
					map: this.map,
					offset: new AMap.Pixel(-10, -10),
				});

				this.endMarker = new AMap.Marker({
					position: path[path.length - 1],
					icon: icon,
					map: this.map,
					offset: new AMap.Pixel(-10, -10),
				});

				this.routeLine = new AMap.Polyline({
					path: path,
					isOutline: true,
					outlineColor: "#ffeeee",
					borderWeight: 2,
					strokeWeight: 5,
					strokeOpacity: 0.9,
					strokeColor: "#0091ff",
					lineJoin: "round",
				});

				this.map.add(this.routeLine);

				// 调整视野达到最佳显示区域
				this.map.setFitView([this.startMarker, this.endMarker, this.routeLine]);
			},
			parseRouteToPath(route) {
				var path = [];

				for (var i = 0, l = route.steps.length; i < l; i++) {
					var step = route.steps[i];

					for (var j = 0, n = step.path.length; j < n; j++) {
						path.push(step.path[j]);
					}
				}

				return path;
			},
		},
	};
</script>

<style>
	#container {
		width: 100%;
		height: 88vh;
	}

	.map-box {
		position: relative;



	}

	.carInfoBox {
		position: absolute;
		z-index: 999;
		left: 0px;
		top: 86px;
		background: #283997cf;
		color: #fff;
		padding: 20px;
		font-size: 14px;
	}

	.rote-box {
		padding: 10px;
	}

	.title {
		margin-bottom: 10px;
	}

	.carNo {
		margin-left: 20px;
	}

	.carInfo {
		margin-bottom: 30px;
		font-size: 20px;
	}

	.returnBtn {
		position: absolute;
		z-index: 999;
		right: 20px;
		top: 20px;
		padding: 10px 30px;
		border: 1px solid #3c9efb;
		background: #1e4bc3;
		color: #f2f2f2;
		cursor: pointer;
	}


	.el-timeline-item__node--large {
		left: -5px;
		width: 20px;
		height: 20px;
	}

	.el-timeline-item__wrapper {
		padding-bottom: 20px;
	}

	.el-timeline-item__content {
		color: #fff !important;
	}

	.el-timeline-item__timestamp {
		color: #fff;
	}

	.el-timeline-item {
		padding-bottom: 0;
	}

	.el-timeline-item:nth-child(2) {
		.el-timeline-item__wrapper {
			padding-bottom: 0px;
		}
	}

	.amap-info-content {
		background: #283997cf;
	}

	.bottom-center .amap-info-sharp {
		border-color: #283997cf;
		border-left: 8px solid transparent;
		border-right: 8px solid transparent;
	}

	.map-info {
		font-size: 14px;
		padding: 10px 16px 8px;
		background: #283997cf;
		color: bisque;
	}

	.info-item {
		width: 145px;
		display: flex;


	}


	.line {
		width: 100%;
		height: 1px;
		background: #6ca3da;
	}

	.button {
		text-align: center;
		padding: 6px 0;
		cursor: pointer;
	}

	.search-main {
		display: flex;
		padding: 20px 10px;
	}
</style>
